import React, { Component } from 'react'
import MemoCol from './MemoCol'


export default class MemoContent extends Component {


    render() {

        return (

            <div className='MemoContentContainer'>

                <div className='MemoSubCatgContainer'>
                    <span className='MemoSubCatg'>Not Started</span>
                    <MemoCol catg1={this.props.catg1} catg2='0' isLogin={this.props.isLogin} />
                </div>

                <div className='MemoSubCatgContainer'>
                    <span className='MemoSubCatg'>In Progress</span>
                    <MemoCol catg1={this.props.catg1} catg2='1' isLogin={this.props.isLogin} />
                </div>

                <div className='MemoSubCatgContainer'>
                    <span className='MemoSubCatg'>Completed</span>
                    <MemoCol catg1={this.props.catg1} catg2='2' isLogin={this.props.isLogin} />
                </div>            

                <div className='MemoSubCatgContainer'>
                    <span className='MemoSubCatg'>Canceled</span>
                    <MemoCol catg1={this.props.catg1} catg2='3' isLogin={this.props.isLogin} />
                </div>
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/memo/MemoContent.js